import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import htmlToPdfmake from "html-to-pdfmake"
import pdfMake from 'pdfmake/build/pdfmake';
//import pdfFonts from 'pdfmake/build/vfs_fonts';
//import pdfFonts from '../assets/fonts/fontlist.js';
import Swal from 'sweetalert2';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export class Data {

  constructor(
    public UserLoggedIn: boolean,
    public UserName: string) { }
}

@Injectable()
export class AppService {

  constructor(public http: HttpClient) {
  }

  public Data = new Data(
    false, // UserLoggedIn
    '',    // UserName
  )

  public UserLoggedIn() {
    this.Data.UserLoggedIn = true;
  }
  public UserLoggedOut() {
    this.Data.UserLoggedIn = false;
  }

  InformationAlert(postion, icon, title, text) {
    Swal.fire({
      position: postion,
      icon: icon,
      title: title,
      // text:text,
      html: '<strong>' + text + ' </strong>',

    });
  }


  ConfirmationAlert(postion, icon, title, text, confirmButtonText, cancelButtonText) {
    return Swal.fire({
      position: postion,
      icon: icon,
      title: title,
      text: text,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
    })

  }



  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }


}
